import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultOptions = {
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json, text/javascript, */*'
  }
};
var isProduction = function isProduction() {
  return process.env.NODE_ENV === 'production';
};
var MAX_REQUESTS_PER_INTERVAL = 5;
var INTERVAL_MS = 1000;
var requestQueue = [];
var isProcessingQueue = false;
var processQueue = function processQueue() {
  if (isProcessingQueue) {
    return;
  }
  isProcessingQueue = true;
  var _processNextBatch = function processNextBatch() {
    if (requestQueue.length === 0) {
      isProcessingQueue = false;
      return;
    }
    var batch = requestQueue.splice(0, MAX_REQUESTS_PER_INTERVAL);
    batch.forEach(function (_ref) {
      var body = _ref.body,
        endpoint = _ref.endpoint;
      fetch(endpoint, _objectSpread(_objectSpread({}, defaultOptions), {}, {
        method: 'POST',
        body: body
      }));
    });
    setTimeout(_processNextBatch, INTERVAL_MS);
  };
  _processNextBatch();
};
var sendToServerBatched = function sendToServerBatched(body, endpoint) {
  requestQueue.push({
    body: body,
    endpoint: endpoint
  });
  // Start processing the logging queue if not already started
  processQueue();
};
var sendToConsole = function sendToConsole(body, endpoint, level, message, eventType, event) {
  // eslint-disable-next-line no-console
  console[level]('%c%s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
  var currentWindow = window;
  if (!isProduction() && currentWindow.Cypress) {
    if (!currentWindow.cypressSafeErrorsLog) {
      currentWindow.cypressSafeErrorsLog = [];
    }
    currentWindow.cypressSafeErrorsLog.push({
      body: body,
      endpoint: endpoint,
      level: level,
      message: message
    });
  }
  if (eventType !== 'object') {
    var errorMessage = "Invalid log API usage: expected event of type 'object', but was ".concat(eventType);
    // eslint-disable-next-line no-console
    console.error(errorMessage);
  }
  if (typeof body !== 'string') {
    var _errorMessage = "Invalid log API usage: expected event of type 'string', but was ".concat(eventType, "; message will be replaced by: ").concat(String(message));
    // eslint-disable-next-line no-console
    console.error(_errorMessage);
  }
  return Promise.resolve();
};
var transformData = function transformData(location, message, event) {
  var _window;
  return {
    sentFrom: location,
    message: String(message),
    event: event,
    buildKey: (_window = window) === null || _window === void 0 ? void 0 : _window.BUILD_KEY,
    logTime: new Date().toISOString()
  };
};
var sendData = function sendData(level, location, message) {
  var event = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var data = transformData(location, message, event);
  var body = JSON.stringify(data);
  var endpoint = "/rest/internal/2/log/safe/".concat(level);
  if (isProduction()) {
    return sendToServerBatched(body, endpoint);
  }
  return sendToConsole(body, endpoint, level, message, _typeof(event), event);
};
export var safeWarnWithoutCustomerData = function safeWarnWithoutCustomerData(location, message, event) {
  sendData('warn', location, message, event);
};